import { DeleteCenterProgramRequest } from '../../../lib/types/models/center/center'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const deleteCenterCourse = async (input: DeleteCenterProgramRequest) => {
  const { id, centerId } = input
  return restApiClient
    .url(constructApiUrl(API.centers.deleteCenterCourse.url, { centerId, courseId: id }))
    .delete()
}
